import { Button } from "@/components/ui/button";
import { Menu, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { UserNav } from "./UserNav";

export default function Header({
  setIsSidebarOpen,
}: {
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
}) {
  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-background/95 px-4 backdrop-blur-sm supports-[backdrop-filter]:bg-background/85 sm:px-8">
      <div className="flex flex-1 items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="-ml-2 min-[1100px]:hidden text-foreground"
          onClick={() => setIsSidebarOpen(true)}
        >
          <Menu className="size-5" />
        </Button>

        <div className="relative hidden w-full max-w-sm sm:block">
          <Search
            className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground"
            aria-hidden
          />
          <Input
            type="search"
            placeholder="Search domains..."
            className="h-9 border-border bg-muted/50 pl-9 text-sm text-foreground shadow-none placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring/40"
          />
        </div>
      </div>

      {/* Add Domain removed (owner, 08.10.2026): no add-domain entry point for any
          user or group. The AddDomainDialog component, useAddDomainsMutation and
          the legacy route action are now unreferenced — safe to delete fully in a
          follow-up. */}
      <div className="flex items-center gap-4">
        <UserNav />
      </div>
    </header>
  );
}
